import { Amplify, Auth } from 'aws-amplify'
import awsconfig from '../../aws-exports'
import { transformCognitoUserData } from '../../utils/aws-cognito-utils'

Amplify.configure(awsconfig)

// Display user Attributes
export async function getAuthenticatedUserInfo() {
  const response = await Auth.currentAuthenticatedUser()
  let userInfo
  if (response) {
    userInfo = transformCognitoUserData(response)
  }
  return userInfo
}
